import { axiosInstance } from "../../utils";

const actions = {
    FETCH_BANNERS_REQUESTED: 'FETCH_BANNERS_REQUESTED',
    FETCH_BANNERS_SUCCEEDED: 'FETCH_BANNERS_SUCCEEDED',
    FETCH_BANNERS_FAILED: 'FETCH_BANNERS_FAILED',

    FETCH_BANNER_REQUESTED: 'FETCH_BANNER_REQUESTED',
    FETCH_BANNER_SUCCEEDED: 'FETCH_BANNER_SUCCEEDED',
    FETCH_BANNER_FAILED: 'FETCH_BANNER_FAILED',

    DELETE_BANNER_REQUESTED: 'DELETE_BANNER_REQUESTED',
    DELETE_BANNER_SUCCEEDED: 'DELETE_BANNER_SUCCEEDED',
    DELETE_BANNER_FAILED: 'DELETE_BANNER_FAILED',

    removeBanner: (id = undefined) => {
        return {
            type: actions.DELETE_BANNER_REQUESTED,
            payload: id
        }
    },

    deleteBanner: async (id = undefined) => {
        const url = `banners/`+id;

        try {
            const response = await axiosInstance.delete(url);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    fetchBanners: (params = undefined) => {
        return {
            type: actions.FETCH_BANNERS_REQUESTED,
            payload: params
        }
    },

    fetchBanner: (id = undefined) => {
        return {
            type: actions.FETCH_BANNER_REQUESTED,
            payload: id
        }
    },

    getBanners: async (params = undefined) => {
        const url = `banners`;

        try {
            const banners = await axiosInstance.get(url,{ params });
            return banners.data;
        } catch (error) {
            throw error;
        }
    },

    getBanner: async (bannerId = undefined) => {
        const url = `banners/`+bannerId;

        try {
            const banner = await axiosInstance.get(url);
            return banner.data;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
